module.exports = __webpack_public_path__ + "static/media/foto2.832c4bd6.png";